<template>
  <!-- 课程11 -->
  <div class="lessonEleven">
    <div class="web_content">
      <div class="title">第4章 机器学习（11 最近邻分类器）</div>
      <div class="content">
        长期以来，人们一直认为学习是智能的关键要素，这既适用于自然智能（我们都通过学习变得更聪明），也适用于人工智能。
        <br />在第 4 章中，我们将介绍以下部分。
      </div>
       <div class="content">
        一、
        <span @click="jumpOne" style="color:#0090ff;cursor: pointer;" class="index">机器学习的类型（---）</span>
      </div>
      <div class="content">
        二、
        <span  @click="jumpTow" style="color:#0090ff;cursor: pointer;" class="index">最近邻分类器（0/2）</span>
      </div>
      <div class="content">
        三、
        <span @click="jumpThree" style="color:#0090ff;cursor: pointer;" class="index">回归（0/4）</span>
      </div>

      <div class="title-child" id="productId">第2节 最近邻分类器</div>

      <div class="content">监督学习是机器学习中的一种训练方式，通常有两个任务，即分类和回归。这里我们主要讨论分类。</div>

      <div class="title-child-bold" >一、最近邻分类器</div>
      <div class="content">最近邻分类器是最简单的分类器之一。当给定一个要分类的项时，它会找到与新项最相似的训练数据项，并输出其标签。</div>

      <div class="title-child-bold">1. 分类的训练与测试</div>
      <div class="content">图1所示给出了一个分类训练与测试的示例。</div>

      <img src="../assets/11-01.png" />

      <div class="content-imgtext">图1 分类的训练与测试</div>
      <div class="content">
        在上图中，我们显示了一组训练数据项，其中一些属于一个类（绿色），而另一些属于另一类（蓝色）。此外，还有两个测试数据项，即星星，我们将使用最近邻方法对它们进行分类。
        <br />这两个测试项都归为“绿色”类别，因为它们最近的邻居都为绿色（见上图右图）。
        <br />点在图中的位置以某种方式表示数据项的属性。由于我们是在二维平面上绘制图表，因而这些可用于比较的数据项具有两个属性：上下或左右移动。想象一下，例如在诊所代表患者的年龄和血糖水平。但是，以上图表应仅作为可视化工具来说明一般的想法，即将类值与相似性或接近度相关联。总的想法决不限于二维，并且最邻近分类器可以轻松地应用于具有比二维更多特性的数据项。
      </div>

      <div class="title-child-bold">2. 最近邻是什么意思？</div>

      <div class="content">
        与最近邻分类器相关的一个有趣问题是实例之间距离或相似性的定义。在上图中，我们默认使用标准几何距离，技术上称为欧几里得距离。这只是意味着，如果将这些点绘制在一张纸上（或显示在屏幕上），则可以通过将一条线直接拉到另一条线的方式来测量任意两个项之间的距离。
        <br />注意：使用几何距离来确定哪个是最接近的项可能并不总是合理的，甚至可能是不可能的：例如，输入的类型可能是文本，不清楚在几何图形中如何绘制这些项以及如何测量距离。因此，您应该根据具体情况选择距离来度量。
        <br />在MNIST数字识别中，一种常用的测量图像相似度的方法是逐像素匹配计数。换句话说，我们将每个图像左上角的像素相互比较，如果它们的颜色（灰度）越相似，两个图像就越相似。我们还应比较每个图像右下角的像素，以及中间的所有像素。这项技术对图像的移动或缩放非常敏感：如果我们取一个“1”的图像，并将其左移或右移，结果是两个图像（移动前后）非常不同，因为黑色像素在两个图像中处于不同的位置。幸运的是，MNIST数据通过对图像进行中心化预处理，从而缓解了这个问题。
      </div>

      <div class="title-child-bold">二、最近邻方法应用</div>

      <div class="content">最近邻方法应用程序的一个典型示例是预测AI应用程序（如推荐系统）中的用户行为，如音乐推送，如图2所示。</div>
      <img src="../assets/11-02.png" />

      <div class="content-imgtext">图2 音乐推送</div>

      <div class="content">
        这个想法是使用一个非常简单的原则，即具有相似过去行为的用户倾向于具有相似的未来行为。想象一下一个音乐推荐系统，该系统收集有关用户收听行为的数据。假设您听过1980年代的迪斯科音乐（只是为了论证）。有一天，服务提供商获得了一部很难找到的1980年代迪斯科经典唱片，并将其添加到音乐库中。系统现在需要预测您是否喜欢它。一种方法是使用由服务提供商的优秀人员输入的方式，他会输入有关流派，艺术家和其他元数据的信息。然而，这些信息相对稀少和粗糙，只能给出粗略的预测。
        <br />当前的推荐系统使用的是所谓的协作过滤，而不是手动输入元数据。它的协作方面是使用其他用户的数据来预测您的偏好。“过滤”一词指的是你将只被推荐通过过滤的内容：你可能喜欢的内容将通过，其他内容将不通过（这种过滤可能导致所谓的过滤泡沫，我们在第一章中提到过，稍后我们将返回去了解）。
        <br />现在让我们假设其他听过80年代迪斯科音乐的用户喜欢这个新版本，并不断地听着。该系统将识别您和其他80年代迪斯科狂热者共享的类似过去的行为，并且由于像您这样的其他用户喜欢新版本，系统会预测您也会这样做。因此，它将显示在您的推荐列表的顶部。在另一种现实中，添加的歌曲可能不太好，并且其他用户的行为与您过去的行为类似，但您却不太喜欢它。在这种情况下，系统不会理会向您推荐它，或者至少它不会在您的推荐列表中处于首位。
        <br />以下练习将说明此想法。
      </div>

      <div class="title-child-bold">【知识巩固】</div>
      <div class="title-child-bold">练习14：购买了类似产品的客户</div>

      <div class="content">
        在本练习中，我们将为在线购物应用程序构建一个简单的推荐系统，其中记录用户的购买历史，并用于预测用户下一步可能购买哪些产品。
        我们有六个用户的数据。对于每个用户，我们都记录了他们最近购买四种商品的历史记录，以及随后购买的商品：
      </div>

      <div align="center">
        <table bordercolor="green" border="1">
          <tbody>
            <tr>
              <td align="center">
                <font size="5">用户</font>
              </td>
              <td align="center" colspan="4">
                <font size="5">购物历史</font>
              </td>
              <td align="center">
                <font size="5">采购</font>
              </td>
            </tr>
            <tr>
              <td>
                <font size="5">宋妮</font>
              </td>
              <td>
                <font size="5">拳击手套</font>
              </td>
              <td>
                <font size="5">《白鲸》（小说）</font>
              </td>
              <td>
                <font size="5">头戴式耳机</font>
              </td>
              <td>
                <font size="5">墨镜</font>
              </td>
              <td>
                <font size="5">咖啡豆</font>
              </td>
            </tr>
            <tr>
              <td>
                <font size="5">朱尼</font>
              </td>
              <td>
                <font size="5">T恤衫</font>
              </td>
              <td>
                <font size="5">咖啡豆</font>
              </td>
              <td>
                <font size="5">咖啡机</font>
              </td>
              <td>
                <font size="5">咖啡豆</font>
              </td>
              <td>
                <font size="5">咖啡豆</font>
              </td>
            </tr>
            <tr>
              <td>
                <font size="5">李娜</font>
              </td>
              <td>
                <font size="5">墨镜</font>
              </td>
              <td>
                <font size="5">球鞋</font>
              </td>
              <td>
                <font size="5">T恤衫</font>
              </td>
              <td>
                <font size="5">球鞋</font>
              </td>
              <td>
                <font size="5">拉格羊毛袜</font>
              </td>
            </tr>
            <tr>
              <td>
                <font size="5">杜维克</font>
              </td>
              <td>
                <font size="5">《2001:太空漫游》(DVD)</font>
              </td>
              <td>
                <font size="5">头戴式耳机</font>
              </td>
              <td>
                <font size="5">T恤衫</font>
              </td>
              <td>
                <font size="5">拳击手套</font>
              </td>
              <td>
                <font size="5">人字拖鞋</font>
              </td>
            </tr>
            <tr>
              <td>
                <font size="5">王维</font>
              </td>
              <td>
                <font size="5">T恤衫</font>
              </td>
              <td>
                <font size="5">人字拖鞋</font>
              </td>
              <td>
                <font size="5">墨镜</font>
              </td>
              <td>
                <font size="5">《白鲸》（小说）</font>
              </td>
              <td>
                <font size="5">防晒霜</font>
              </td>
            </tr>
            <tr>
              <td>
                <font size="5">秦穆</font>
              </td>
              <td>
                <font size="5">《白鲸》（小说）</font>
              </td>
              <td>
                <font size="5">咖啡豆</font>
              </td>
              <td>
                <font size="5">《2001:太空漫游》(DVD)</font>
              </td>
              <td>
                <font size="5">头戴式耳机</font>
              </td>
              <td>
                <font size="5">咖啡豆</font>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="content">
        最近的一次购买是最右边一列，例如，在购买T恤衫，人字拖鞋，太阳镜和《白鲸》（小说）之后，王维购买了防晒霜。我们的假设是，在购买类似物品后，其他用户也可能会购买防晒霜。
        <br />要应用最近邻方法，我们需要定义最近的含义。这可以通过许多不同的方法来完成，其中某些方法比其他方法效果更好。让我们使用购物历史记录来统计两个用户购买了多少商品，以定义相似度（“接近度”）。
        <br />例如，用户王维和杜维克都购买了一件T恤衫，因此它们的相似度为1。请注意，触发器不计算在内，因为我们在计算相似度时不包括最近购买的东西，这是出于其他目的而保留的。
        <br />我们的任务是预测已购买以下产品的客户赵维斯的下一次购买：
      </div>

      <div align="center">
        <table bordercolor="green" border="1">
          <tbody>
            <tr>
              <td align="center">
                <font size="5">用户</font>
              </td>
              <td align="center" colspan="4">
                <font size="5">购物历史</font>
              </td>
              <td align="center">
                <font size="5">采购</font>
              </td>
            </tr>
            <tr>
              <td>
                <font size="5">赵维斯</font>
              </td>
              <td>
                <font size="5">绿茶</font>
              </td>
              <td>
                <font size="5">T恤衫</font>
              </td>
              <td>
                <font size="5">墨镜</font>
              </td>
              <td>
                <font size="5">人字拖鞋</font>
              </td>
              <td>
                <font size="5">
                  <font color="red">?</font>
                </font>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="content">
        您可以将赵维斯视为我们的测试数据，以上六个用户构成了我们的培训数据。
        <br />进行如下：
        <br />计算赵维斯在培训数据中相对于六个用户的相似度（通过将用户的相似购买次数相加来完成）。
        <br />计算相似度后，通过选择最大的相似度来确定与赵维斯最相似的用户。
        <br />通过查看上一步中最相似的用户的最近一次购买（表中最右边的列），预测赵维斯下一步可能购买什么。
        <br />
      </div>
      <div class="content">谁是最接近赵维斯的用户？</div>
      <span class="content" style="textAlign:center;">回答:<input type="text" class="anwserInput" :disabled="contenteditable"></span>
      <div class="content">赵维斯的预计购买是什么？</div>

      <span class="content" style="textAlign:center;">回答:<input type="text" class="anwserInput" :disabled="contenteditable"></span>
<br/>
            <button class="sentBtn" style="marginLeft:290px;" @click="sentBtnOne">提交</button>


   <img src="../assets/11-03.png" />

     <div class="content">
 　在上面的示例中，我们只有六个用户的数据，我们的预测可能非常不可靠。然而，在线购物网站通常有数百万用户，他们产生的数据量是巨大的。在很多情况下，有一大群用户的过去行为与你的非常相似，他们的购买历史很好地表明了你的兴趣。 <br/>
　　这些预测也可以是自我实现的预言，因为如果系统向您推荐产品，您更有可能购买该产品，这使得评估它们实际工作的好坏变得很困难。同样的推荐系统也用于向用户推荐音乐、电影、新闻和社交媒体内容。在新闻和社交媒体的背景下，由这些系统创建的过滤器可能导致过滤泡沫。
      </div>
<div class="title-child-bold">练习15：过滤气泡</div>


  <div class="content">
 　　如上所述，推荐用户可能会点击或喜欢的社交媒体内容的新闻，可能会导致过滤气泡，其中用户只能看到与他们自己的价值观和观点一致的内容。 <br/>
　　您认为过滤气泡有害吗？毕竟，它们是通过推荐用户喜欢的内容来创建的。过滤气泡会带来哪些负面后果（如果有）？可随时从其他来源寻找更多信息。  <br/>
　　想办法避免过滤气泡，同时仍然能够推荐适合个人喜好的内容。至少提出一个建议。您可以从其他来源寻找想法，但我们也想听听您自己的想法！  <br/>
　　注意：每个部分的答案至少应为几句话。  <br/>
　　您的答案应在40到100个字之间 
      </div>


 <div class="content" style="textAlign:center;">你的答案:<input type="text" class="anwserInput" :disabled="contenteditable"></div>

            <button class="sentBtn" style="marginLeft:290px;" @click="sentBtnOne">提交</button>


    </div>
           <div class="backBtn" style="margin:20px auto;textAlign:center;">
        <button @click="goBlank" style="cursor: pointer;">上一页</button>
        <button @click="goMune"  style="marginLeft:15px;marginRight:15px;cursor: pointer;">返回目录页</button>
        <button @click="NextClk" style="cursor: pointer;">下一页</button>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textarea1: "",
      textarea2: "",
          contenteditable:false,
    };
  },
  created() {},
  computed: {},
  components: {},
  mounted() {},
  methods: {

    sentBtnOne(){
      this.contenteditable = true;

    },

 jumpOne(){
      this.$router.push('/lessonTen');
    },
    jumpTow(){
       const returnEle = document.querySelector("#productId");  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        document.querySelector("counter1").scrollIntoView(true); //这里的counter1是将要返回地方的id
    },
   
    jumpThree(){
      this.$router.push('/lessonTwelve');
    },
    goBlank(){
      this.$router.push('/lessonTen');
    },
    goMune(){
      this.$router.push('/');
    },
    NextClk(){
      this.$router.push('/lessonTwelve');
    },
  },
};
</script>

<style scoped>
.lessonEleven {
  width: 100%;
}
.web_content {
  width: 650px;
  margin: 0 auto;
  padding: 0px 75px;
  background: #fff;
}
.title {
  font-size: 22px;
  color: #000;
  font-weight: bold;
  margin-top: 50px;
}
.content {
  text-indent: 2em;
  font-size: 16px;
  line-height: 35px;
}
.index {
  font-size: 16px;
  color: #0090ff;
  line-height: 15px;
}
.title-child {
  font-size: 22px;
  color: #000;
  margin-top: 30px;
}
.title-child-bold {
  font-size: 16px;
  color: #000;
  margin-top: 30px;

  font-weight: bold;
}

.content-red {
  color: #f15a23;
  font-size: 16px;
  line-height: 35px;
  text-indent: 2em;
}
.content-imgtext {
  align-items: center;
}
.sentBtn{
  width: 100px;
  margin-left: 240px;
  margin-top: 25px;
  margin-bottom: 25px;
  cursor: pointer;
}
.backBtn button{
  width: 100px;
}
</style>

















// WEBPACK FOOTER //
// src/components/lessonEleven.vue